﻿import defaultApp from './defaultApp.js';
import ListItem from './components/ListItem.vue';
import Skeleton from './components/Skeleton.vue';
import { setCookie, getCookie, deleteCookie } from '../functions';
import { DayPilot, DayPilotCalendar, DayPilotNavigator } from '@daypilot/daypilot-lite-vue';
import Datepicker from 'vanillajs-datepicker/Datepicker';
import nl from 'vanillajs-datepicker/locales/nl';
const axios = require('axios');
Object.assign(Datepicker.locales, nl);

const datePickerOptions = {
    autohide: true,
    format: 'dd-mm-yyyy',
    nextArrow: '<i class="fa-solid fa-angle-right"></i>',
    prevArrow: '<i class="fa-solid fa-angle-left"></i>',
    orientation: 'bottom',
    clearButton: true
}

const defaultCalendarConfig = {
    viewType: 'Days',
    theme: 'fom',
    headerDateFormat: 'ddd d MMM',
    heightSpec: 'BusinessHoursNoScroll',
    cellHeight: 70,
    durationBarVisible: true,
    bubble: null,
    timeRangeSelectedHandling: 'Disabled',
    eventMoveHandling: 'Disabled',
    eventResizeHandling: 'Disabled'
};

const agendaApp = {
    components: { ListItem, Skeleton, DayPilotCalendar, DayPilot, DayPilotNavigator },
    ...defaultApp,
    data() {
        return {
            ...defaultApp.data(),
            dataLocation: '',
            dataShowBanners: false,
            dataLanguageCode: 'nl-NL',
            dataLanguage: 'nl',
            dataFestival: {
                startDate: '',
                duration: '',
                startTime: '',
                endTime: '',
            },
            dataFavourites: {
                title: '',
                add: '',
                remove: ''
            },
            highlightFavourites: false,
            filterField: '',
            filterValue: [],
            datepicker: null,
            filterDate: '',
            listView: true,
            showMultipleDropdown: false,
            listItems: [],
            favoriteItems: [],
            wishlist: [],
            page: 1,
            searchText: '',
            calendarConfig: {},
            calendarStickyHeader: false,
            step: 1,
            addDays: 1,
            numberOfDays: 2,
            next: true,
            prev: false,
            breakPoints: {
                belowDesktop: window.matchMedia('(max-width: 1024px)'),
                belowWidescreen: window.matchMedia('(max-width: 1407px)')
            },
            moreInfo: ''
        }
    },
    watch: {
        highlightFavourites(newView, oldView) {
            if (newView) {
                setCookie('highlight', 'true', 365);
            } else {
                deleteCookie('highlight');
            }
        },
        listView(newView, oldView) {
            if (newView) {
                setCookie('listview', 'true', 365);
                this.calendar.hide();
            } else {
                deleteCookie('listview');
                this.calendar.show();
            }
        },
        filtersActive(active) {
            if (active) {
                this.calendarConfig.days = parseInt(this.dataFestival.duration);
                this.next = false;
                this.prev = false;
            }
        }
    },
    computed: {
        ...defaultApp.computed,
        calendar() {
            if (!this.$refs.calendar) return null;
            return this.$refs.calendar.control;
        },
        calendarElm() {
            return document.getElementById('dp');
        },
        filterItems() {
            if (!this.filtersChosen) return [];
            if (this.filterField !== '' && this.filterValue.length) {
                return [{
                    Key: this.filterField,
                    Values: this.filterValue,
                    Operator: 'In'
                }]
            }
            if (this.dataOverruleIds.length) {
                return [{
                    Key: 'cmsNodeId',
                    Values: this.dataOverruleIds,
                    Operator: 'In'
                }]
            } else if (this.dataLocation !== '') {
                return [{
                    Key: 'location.id',
                    Values: [this.dataLocation],
                    Operator: 'In'
                }]
            }
            let fc = this.data.facets.filter(f => f.values.length).map(facet => {
                return {
                    Key: facet.alias,
                    Values: facet.values,
                    Operator: facet.alias === 'filterDate' ? 'Eq' : 'In'
                }
            });
            return fc
        },
        allDays() {
            if (!this.data.facets.length) return [];
            let dateFacet = this.data.facets.find(facet => facet.alias === 'filterDate');
            if (!dateFacet) return [];
            let dates = dateFacet.options.map(option => new Intl.DateTimeFormat(this.dataLanguageCode, { day: '2-digit', month: '2-digit', year: 'numeric' }).format(this.toDateObj(option.valueAlias)));
            return dates;
        },
        wishlistIds() {
            let result = this.wishlist.map(event => event.id);
            return result;
        }
    },
    methods: {
        ...defaultApp.methods,
        async init() {
            this.loading = true;
            this.dataShowBanners = this.$el.hasAttribute('data-showbanners');
            this.dataWidget = this.$el.hasAttribute('data-widget');
            if (this.$el.dataset.overruleids) this.dataOverruleIds = this.$el.dataset.overruleids.split(',');
            if (this.$el.dataset.language) this.dataLanguageCode = this.$el.dataset.language;
            if (this.$el.dataset.api) this.dataApi = this.$el.dataset.api + '?lang=' + this.dataLanguageCode;
            if (this.$el.dataset.limit) this.dataLimit = parseInt(this.$el.dataset.limit);
            if (this.$el.dataset.sortkey) this.dataSortKey = this.$el.dataset.sortkey;
            if (this.$el.dataset.sortdirection) this.dataSortDirection = this.$el.dataset.sortdirection;
            if (this.$el.dataset.location) this.dataLocation = this.$el.dataset.location;
            if (this.$el.dataset.listview) this.listView = this.$el.dataset.listview === 'true' || getCookie('listview') !== "";
            if (this.$el.dataset.filterfield) this.filterField = this.$el.dataset.filterfield;
            if (this.$el.dataset.filtervalue) this.filterValue = this.$el.dataset.filtervalue.split(',');
            if (this.$el.dataset.startdate) this.dataFestival.startDate = this.$el.dataset.startdate;
            if (this.$el.dataset.numberofdays) this.dataFestival.duration = this.$el.dataset.numberofdays;
            if (this.$el.dataset.earliesttime) this.dataFestival.startTime = this.$el.dataset.earliesttime;
            if (this.$el.dataset.latesttime) this.dataFestival.endTime = this.$el.dataset.latesttime;
            if (this.$el.dataset.favouritetitle) this.dataFavourites.title = this.$el.dataset.favouritetitle;
            if (this.$el.dataset.favouriteadd) this.dataFavourites.add = this.$el.dataset.favouriteadd;
            if (this.$el.dataset.favouriteremove) this.dataFavourites.remove = this.$el.dataset.favouriteremove;
            if (this.$el.dataset.moreinfo) this.moreInfo = this.$el.dataset.moreinfo;
            this.language = this.dataLanguageCode.split('-')[0];
            if (!this.isDeepEmpty(this.dataFestival)) {
                this.calendarConfig = defaultCalendarConfig;
                this.calendarConfig.startDate = this.dataFestival.startDate;
                this.calendarConfig.days = this.dataFestival.duration;
                this.calendarConfig.locale = this.dataLanguageCode.toLowerCase();
                this.calendarConfig.businessBeginsHour = parseInt(this.dataFestival.startTime);
                this.calendarConfig.businessEndsHour = parseInt(this.dataFestival.endTime);
            }

            // Construct query model and alter data props based on URL search params.
            const urlParams = new URLSearchParams(window.location.search);

            let pageParam = urlParams.has('page') ? parseInt(urlParams.get('page')) : 0;
            if (pageParam) urlParams.delete('page');
            if (pageParam < 2) pageParam = 0;
            this.searchText = urlParams.has('text') ? urlParams.get('text') : '';
            if (this.searchText) urlParams.delete('text');
            let filterParams = urlParams.toString() ? urlParams : null;

            let tempLimit = this.dataLimit;
            if (pageParam && !this.dataWidget) {
                this.page = pageParam;
                this.dataLimit = this.dataLimit * this.page;
            }

            if (filterParams) {
                let filterQuery = [];
                filterParams.forEach((value, key) => {
                    if (key !== 'q') {
                        filterQuery.push({ Key: key, Values: value.split(','), Operator: key === 'filterDate' ? 'Eq' : 'In' });
                        if (key === 'filterDate') this.filterDate = this.reverseDate(value);
                    }
                });
                if (filterQuery.length) this.queryModel.FilterItems = filterQuery;
            }

            if (this.dataOverruleIds.length) {
                const overruleResponse = await this.fetchData();
                if (overruleResponse && overruleResponse.data && overruleResponse.data.items && overruleResponse.data.items.length) {
                    overruleResponse.data.items = overruleResponse.data.items.sort((a, b) => this.dataOverruleIds.indexOf(a.id) - this.dataOverruleIds.indexOf(b.id));
                }
                this.setData(overruleResponse);
                this.dataOverruleIds = [];
            } else {
                const response = await this.fetchData();
                this.setData(response);
                this.dataLimit = tempLimit;
            }

            if (this.itemsSet) {
                this.data.items = this.removeDuplicatesById(this.data.items);
                if (this.dataWidget) this.data.items = this.data.items.slice(0, this.dataLimit);
            }
            this.loading = false;

            if (this.calendar) {
                this.breakPoints.belowDesktop.addEventListener('change', this.setNrOfDays);
                this.setNrOfDays(this.breakPoints.belowDesktop);
                this.breakPoints.belowWidescreen.addEventListener('change', this.setNrOfDays);
                this.setNrOfDays(this.breakPoints.belowWidescreen);
                if (this.listView) this.calendar.hide();
                this.calendarConfig.onEventClick = (args) => {
                    const event = this.data.items.find((e) => e.id === args.e.data.id);
                    if (!event) {
                        console.error(`No event found with id ${args.e.data.id}`);
                        return;
                    }
                    let wishlist = JSON.parse(localStorage.getItem('wishlist')) || [];
                    event.favorite = wishlist.some((item) => item.id === event.id);
                    let imageClass = event.imageSets.length ? '' : ' no-image';
                    let imageDateBlock = event.imageSets && event.imageSets.length ? `
                        <div class="list-item-visual">
                            <picture class="image list-item-image has-shape-rounded">
                                <source srcset="${event.imageSets[0].originalUrl}?width=272&amp;height=363&amp;rnd=133108350704700000 1x,${event.imageSets[0].originalUrl}?width=408&amp;height=544&amp;rnd=133108350704700000 1.5x,${event.imageSets[0].originalUrl}?width=544&amp;height=726&amp;rnd=133108350704700000 2x" sizes="272px" media="(max-width: 768px)">
                                <source srcset="${event.imageSets[0].originalUrl}?width=342&amp;height=456&amp;rnd=133108350704700000 1x,${event.imageSets[0].originalUrl}?width=513&amp;height=684&amp;rnd=133108350704700000 1.5x,${event.imageSets[0].originalUrl}?width=684&amp;height=912&amp;rnd=133108350704700000 2x" sizes="342px" media="">
                                <img src="${event.imageSets[0].originalUrl}?width=342&amp;height=456&amp;rnd=133108350704700000" alt="${event.imageSets[0].alias}" width="342" height="456" onerror="this.onerror=null; this.style.backgroundColor='#cccccc'">
                            </picture>
                            <time class="list-item-date" datetime="${event.startDate}">
                                <span class="day">${this.toShortDayStr(event.startDate, this.dataLanguageCode)}</span>
                                <span class="date">${this.toDateStr(event.startDate, this.dataLanguageCode)}</span>
                                <span class="time">${this.toTimeStr(event.startDate, this.dataLanguageCode)}</span>
                            </time>
                        </div>` : `
                        <time class="list-item-date" datetime="${event.startDate}">
                            <span class="day">${this.toShortDayStr(event.startDate, this.dataLanguageCode)}</span>
                            <span class="date">${this.toDateStr(event.startDate, this.dataLanguageCode)}</span>
                            <span class="time">${this.toTimeStr(event.startDate, this.dataLanguageCode)}</span>
                        </time>`;
                    let favoriteClass = event.favorite ? ' is-active' : '';
                    let favoriteTitle = event.favorite ? this.dataFavourites.remove : this.dataFavourites.add;
                    const modalContent = `
                        <div class="list-item-container is-relative${imageClass}">
                            <a href="${event.detailUrl}" class="list-item-link"></a>
                            <div class="is-flex is-block list-item">
                                ${imageDateBlock}
                                <div class="list-item-info-wrapper">
                                    <div class="list-item-info">
                                        <span id="wishlist-${event.id}" class="wishlist-add wishlist-${event.id} has-text-primary${favoriteClass}" data-eventid="${event.id}"
                                                                                                    data-add="${this.dataFavourites.add}"
                                                                                                    data-remove="${this.dataFavourites.remove}"
                                                                                                    data-datetime="${event.startDate}"
                                                                                                    title="${favoriteTitle}"
                                                                                                    id="${event.id}"
                                                                                                    data-productiontitle="${event.name}"
                                                                                                    data-productionsubtitle="${this.toDateStr(event.startDate, this.dataLanguageCode)} - ${this.toTimeStr(event.startDate, this.dataLanguageCode)}">
                                            <span class="icon">
                                                <i class="fa-regular fa-heart fa-xl"></i>
                                                <i class="fa-solid fa-heart fa-xl is-hidden"></i>
                                            </span>
                                        </span>
                                        ${event.location && event.location.title ? `<div class="list-item-location">${event.location.title}</div>` : ''}
                                        ${event.name ? `<h3 class="list-item-title">${event.name}</h3>` : ''}
                                        ${event.subtitle ? `<div class="list-item-subtitle">${event.subtitle}</div>` : ''}
                                        ${event.genre !== null && event.genre.title !== '' ? `<div class="list-item-genre">${event.genre.title}</div>` : ''}
                                        ${event.showLength ? `<div class="list-item-duration">${event.showLength}</div>` : ''}
                                        <span class="list-item-more-info button is-tiny is-white is-outlined is-rounded">
                                            <span>${this.moreInfo}</span>
                                            <span class="icon">
                                                <i class="fa-solid fa-long-arrow-right"></i>
                                            </span>
                                        </span>
                                        ${event.orderButton && event.orderButton.url && event.orderButton.clickable ? `
                                            <a href="${event.orderButton.url}" class="button button-order list-item-button is-large is-primary is-rounded is-motionless">
                                                <span class="icon">
                                                    <i class="fa-solid fa-ticket fa-lg"></i>
                                                </span>
                                                <span>${event.orderButton.text}</span>
                                            </a>` : ''}
                                        ${event.orderButton && !event.orderButton.clickable ? `
                                            <div class="button button-order list-item-button is-disabled is-large is-light is-rounded">${event.orderButton.text}</div>` : ''}
                                    </div>
                                    ${event.extra ? `<div class="list-item-extra">${event.extra}</div>` : ''}
                                </div>
                            </div>
                        </div>
					`;
                    DayPilot.Modal.alert(modalContent, {
                        scrollWithPage: true
                    });
                    setTimeout(() => {
                        const closeButton = document.querySelector('.modal-close-button');
                        if (closeButton) {
                            closeButton.addEventListener('click', () => {
                                DayPilot.Modal.close();
                            });
                        }
                        const wishlistButton = document.getElementById('wishlist-' + event.id);
                        if (wishlistButton) {
                            wishlistButton.addEventListener('click', (e) => { this.addWishlistItem(e) });
                        }
                    }, 0);
                };
            }
        },
        async fetchData() {
            try {
                const response = await axios.post(this.dataApi, this.queryModel);
                return response;
            } catch (error) {
                console.log(error);
            }
        },
        setData(response) {
            if (!response || response.status != 200) return;
            if (!this.loadMore) {
                this.data = response.data;
                this.data.facets = response.data.facets.map(facet => {
                    return {
                        ...facet,
                        values: facet.options.filter(option => option.selected).map(option => option.valueAlias),
                    }
                });
            } else {
                if (response.data.items && response.data.items.length) {
                    response.data.items.forEach(item => {
                        this.data.items.push(item);
                    })
                }
            }
            this.data.items = this.data.items.map(item => {
                return {
                    ...item,
                    favorite: this.wishlistIds.some(wishlistId => wishlistId === item.id),
                }
            });

            if (this.datepicker === null && this.$refs.datepicker) {
                const self = this;
                datePickerOptions.defaultViewDate = this.filterDate === '' ? this.allDays[0] : this.filterDate;
                datePickerOptions.language = this.language;
                datePickerOptions.datesDisabled = function (date) {
                    return !self.allDays.includes(new Intl.DateTimeFormat(self.dataLanguageCode, { day: '2-digit', month: '2-digit', year: 'numeric' }).format(date));
                }
                this.datepicker = new Datepicker(this.$refs.datepicker, datePickerOptions);
                this.$refs.datepicker.addEventListener('changeDate', (e) => {
                    let filterdate = '';
                    if (e.detail.date !== undefined) {
                        self.filterDate = new Intl.DateTimeFormat(self.dataLanguageCode, { day: '2-digit', month: '2-digit', year: 'numeric' }).format(self.toDateObj(e.detail.date));
                        filterdate = self.reverseDate(self.filterDate);
                    } else {
                        self.filterDate = '';
                    }
                    const index = self.filterItems.findIndex(item => item.Key === 'filterDate');
                    if (index > -1) {
                        self.filterItems.splice(index, 1);
                    }
                    if (filterdate.length) {
                        self.filterItems.push({ Key: 'filterDate', Values: [filterdate], Operator: 'Eq' });
                    }
                    self.fetchInitialData();
                });
                this.$refs.datepicker.addEventListener('change', (e) => {
                    if (e.target.value === '') {
                        const index = self.filterItems.findIndex(item => item.Key === 'filterDate');
                        if (index > -1) {
                            self.filterItems.splice(index, 1);
                        }
                        self.filterDate = '';
                        self.fetchInitialData();
                    }
                });
            }

            if (this.calendar) {
                this.setCalendarEvents();
                this.splitFavorites();
            }
        },
        reset() {
            this.data.facets.forEach(facet => facet.values = []);
            this.filterDate = '';
            this.$nextTick(() => {
                this.datepicker.update();
            });
            this.searchText = '';
            this.fetchInitialData();
        },
        showMonth(index, date) {
            let returnVal = null;
            if (index === 0) {
                returnVal = new Intl.DateTimeFormat(this.dataLanguageCode, { month: 'long' }).format(this.toDateObj(date)) + ' ' + this.toDateObj(date).getFullYear();
            } else {
                let prevEvent = this.data.items[index - 1];
                if (prevEvent) {
                    if (this.toDateObj(date).getMonth() !== this.toDateObj(prevEvent.startDate).getMonth() || this.toDateObj(date).getYear() !== this.toDateObj(prevEvent.startDate).getYear()) {
                        returnVal = new Intl.DateTimeFormat(this.dataLanguageCode, { month: 'long' }).format(this.toDateObj(date)) + ' ' + this.toDateObj(date).getFullYear();
                    }
                }
            }
            return returnVal;
        },
        reverseDate(dateString) {
            var dateStringComps = dateString.split("-");
            return dateStringComps[2] + "-" + dateStringComps[1] + "-" + dateStringComps[0]
        },
        updateUrl() {
            if (!this.queryModel.Text && !this.queryModel.FilterItems.length && this.page === 1) {
                history.pushState({}, null, window.location.pathname);
                return;
            }
            const urlParams = new URLSearchParams();
            if (this.queryModel.Text) urlParams.set('text', this.queryModel.Text);
            if (this.queryModel.FilterItems.length) {
                this.queryModel.FilterItems.forEach(filterItem => urlParams.set(filterItem.Key, filterItem.Values.join()))
            }
            if (this.page > 1) urlParams.set('page', this.page);
            history.pushState({}, null, window.location.pathname + '?' + urlParams.toString());
        },
        isSupportWebp() {
            try {
                return document.createElement('canvas').toDataURL('image/webp', 0.5).indexOf('data:image/webp') === 0;
            } catch (err) {
                return false;
            }
        },
        bannerTarget(target) {
            if (target) return '_blank';
            return null;
        },
        splitFavorites() {
            this.favoriteItems = this.data.items.filter(obj => this.wishlistIds.includes(obj.id));
            this.listItems = this.data.items.filter(obj => !this.wishlistIds.includes(obj.id));
        },
        setCalendarEvents() {
            const events = this.data.items.map((event) => ({
                id: event.id,
                start: event.startDate,
                end: event.endDate,
                cssClass: event.favorite && event.hasPassed ? 'is-favourite is-passed' : event.favorite && !event.hasPassed ? 'is-favourite' : !event.favorite && event.hasPassed ? 'is-passed' : '',
                toolTip: event.favorite ? this.dataFavourites.title : '',
                html: `
                <div class="event-time mb-3 has-text-weight-bold is-size-7">${this.toTimeStr(event.startDate, this.dataLanguageCode)} - ${this.toTimeStr(event.endDate, this.dataLanguageCode)}</div>
                <div class="event-name mb-3 has-text-weight-bold is-size-7">${event.name}</div>
                ${event.location ? `<div class="event-location is-size-7">${event.location.name}</div>` : ''}`
            }));
            this.calendar.update({ events });
        },
        navigate(direction) {
            if (direction === 'next') {
                this.addDays = this.numberOfDays;
                if (parseInt(this.dataFestival.duration) - this.step * this.numberOfDays < this.numberOfDays) {
                    this.addDays = parseInt(this.dataFestival.duration) - this.step * this.numberOfDays;
                    this.next = false;
                }
                this.step++;
                this.calendarConfig.startDate = new DayPilot.Date(this.calendarConfig.startDate).addDays(this.addDays);
                this.prev = true;
            } else {
                this.step--;
                if (this.step === 1) this.prev = false;
                this.calendarConfig.startDate = new DayPilot.Date(this.calendarConfig.startDate).addDays(this.addDays * -1);
                this.addDays = this.numberOfDays;
                this.next = true;
            }
            this.setCalendarStickyHeader();
        },
        toggleFullView() {
            this.calendarConfig.startDate = this.dataFestival.startDate;
            this.step = 1;
            if (this.calendarConfig.days !== parseInt(this.dataFestival.duration)) {
                this.calendarConfig.days = parseInt(this.dataFestival.duration);
                this.next = false;
                this.prev = false;
            } else {
                this.calendarConfig.days = this.numberOfDays;
                this.next = true;
                this.prev = false;
            }
            this.setCalendarStickyHeader();
        },
        setNrOfDays(e) {
            this.calendarConfig.startDate = this.dataFestival.startDate;
            this.step = 1;
            this.next = true;
            this.prev = false;
            if (e.media === '(max-width: 1407px)') {
                this.numberOfDays = e.matches ? 2 : 3;
            } else if (e.media === '(max-width: 1024px)') {
                this.numberOfDays = e.matches ? 1 : 2;
            }
            this.calendarConfig.days = this.numberOfDays;
            this.setCalendarStickyHeader();
        },
        setCalendarStickyHeader() {
            this.$nextTick(() => {
                if (this.calendarElm !== null) {
                    let header = this.calendarElm.firstChild.cloneNode(true);
                    header.style.left = this.calendarElm.getBoundingClientRect().left + 'px';
                    header.style.width = this.calendarElm.offsetWidth + 'px';
                    header.classList.add('fom_main', 'fom_header', 'is-hidden');
                    header.id = 'dp-header';
                    if (this.calendarStickyHeader) {
                        document.getElementById('dp-header').replaceWith(header);
                    } else {
                        this.$el.insertBefore(header, this.calendarElm);
                        this.calendarStickyHeader = true;
                    }
                    this.stickIt();
                }
            });
        },
        stickIt() {
            if (this.calendarStickyHeader) {
                let sticky = document.getElementById('dp-header');
                let stickyHeight = sticky.offsetHeight;
                let calendarRect = this.calendarElm.getBoundingClientRect();
                if (calendarRect.top + stickyHeight <= 0 && calendarRect.bottom - stickyHeight >= 0) {
                    sticky.classList.remove('is-hidden');
                } else {
                    sticky.classList.add('is-hidden');
                }
            }
        },
        isDeepEmpty(obj) {
            for (let key in obj) {
                if (obj[key] instanceof Object === true) {
                    if (isEmpty(obj[key]) === false) return false;
                }
                else {
                    if (obj[key].length !== 0) return false;
                }
            }
            return true;
        }
    },
    created() {
        if (getCookie('highlight') !== "") this.highlightFavourites = true;
        this.changeSearchText = this.debounce(event => {
            this.fetchInitialData();
        });
    },
    beforeDestroy() {
        this.breakPoints.belowDesktop.removeEventListener('change', this.setNrOfDays);
        this.breakPoints.belowWidescreen.removeEventListener('change', this.setNrOfDays);
    },
    mounted() {
        if (getCookie('listview') !== "") this.listView = true;
        this.wishlist = localStorage.hasOwnProperty('wishlist') ? JSON.parse(localStorage.wishlist) : [];
        let self = this;
        window.addEventListener('wishlist-localstorage-changed', (event) => {
            self.wishlist = JSON.parse(event.detail.storage);
            self.data.items = self.data.items.map(item => {
                return {
                    ...item,
                    favorite: self.wishlistIds.some(wishlistId => wishlistId === item.id),
                }
            });
            if (this.calendar) {
                this.splitFavorites();
                this.setCalendarEvents();
            }
        });
        window.addEventListener('resize', this.setCalendarStickyHeader);
        window.addEventListener('scroll', this.stickIt);
        this.init();
    }
};

export default agendaApp;
